module.exports = __webpack_public_path__ + "static/media/drill-day-2.c2d08b0f.png";